import script from "./Webcam.vue?vue&type=script&setup=true&lang=js"
export * from "./Webcam.vue?vue&type=script&setup=true&lang=js"

import "./Webcam.vue?vue&type=style&index=0&id=a8acbc7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8acbc7e"]])

export default __exports__